import { useEffect, useState, type FormEvent } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "关于", to: "/about" },
];

export default function SiteHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleSearch = (event: FormEvent) => {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  const isActive = (to: string) => {
    if (to === "/") return location.pathname === "/";
    return location.pathname.startsWith(to);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-movie-2-line text-xl" />
            </span>
            <span className="font-logo text-xl font-extrabold tracking-tight text-foreground-950">
              97<span className="text-accent-500">影院</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`rounded-md px-4 py-2 text-sm font-medium transition-colors cursor-pointer ${
                  isActive(item.to)
                    ? "bg-primary-50 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <form onSubmit={handleSearch} className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-base text-foreground-400" />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影视名称"
                className="h-10 w-52 rounded-full border border-background-300 bg-background-100 pl-9 pr-4 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100"
              />
            </form>
            <Link
              to="/category"
              className="whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              全部分类
            </Link>
          </div>

          <div className="flex items-center gap-2 md:hidden">
            <Link
              to="/search"
              className="flex h-10 w-10 items-center justify-center rounded-full text-foreground-700 hover:bg-background-100"
              aria-label="搜索"
            >
              <i className="ri-search-line text-xl" />
            </Link>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-full text-foreground-700 hover:bg-background-100"
              aria-label="菜单"
            >
              <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-3 md:hidden">
          <form onSubmit={handleSearch} className="relative mb-3">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-base text-foreground-400" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视名称"
              className="h-11 w-full rounded-full border border-background-300 bg-background-100 pl-9 pr-4 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none"
            />
          </form>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`rounded-md px-4 py-3 text-sm font-medium ${
                  isActive(item.to) ? "bg-primary-50 text-primary-700" : "text-foreground-700"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link to="/category" className="rounded-md px-4 py-3 text-sm font-medium text-foreground-700">
              全部分类
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}